import React from "react";
import TodoList from "../src/components/TodoList";
import Navbar from "./components/Navbar";


const App = () => {
  return (
    <div>
      <Navbar/>
      <TodoList />
  
    </div>
  );
};

export default App;
